import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Text,
    View,
    TouchableOpacity,
    ScrollView,
    Image
} from 'react-native'

import { push } from 'react-router-redux'
import styles from './styles'

import Profile from '../../components/profile/index'
import Financials from '../../components/financials/index'
import Modal from '../../components/modal/index'
import Card from '../../components/card/index'
import EmptyCard from '../../components/cardEmpty/index'
import ErrorCard from '../../components/cardError/index'
import LoadingCard from '../../components/cardLoading/index'

import CONSTANTS from '../../constants/constants'

import {
    stateGetIn,
    stateGetInToJS,
    getAvatar,
    prepTransactions,
    dateRangeFormat
} from '../../lib/index'

import MainReducer from '../main/reducer'
import DashboardReducer from './reducer'

class Dashboard extends Component {
    static NAME = 'Dashboard'

    constructor(props) {
        super(props)

        this.state = {
            width: 0,
            height: 0,
            modalOpen: false,
            modalType: null
        }
    }

    componentDidMount() {
        this.checkProfileSettings()
        this.fetchTransactions(null)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.modalType) {
            return {
                modalOpen: true,
                modalType: nextProps.modalType
            }
        } else {
            return null
        }
    }

    openModal(modalType) {
        this.setState({ modalOpen: true, modalType: modalType })
    }

    closeModal = () => {
        this.setState({ modalOpen: false, modalType: null })

        if ('/' !== this.props.path.split('/')[1]) {
            this.props.goHome()
        }
    }

    onLayout(layout) {
        this.setState((state, props) => {
            return {
                width: layout.width,
                height: layout.height
            }
        })
    }

    fetchTransactions(period = 'current', unit = 'week') {
        this.props.fetchTransactions(period, unit)
    }

    checkProfileSettings() {
        if (
            !this.props.user.userSettings.version ||
            20210216 !== this.props.user.userSettings.version
        ) {
            this.props.resetProfileSettings()
        }
    }

    render() {
        const {
            isLoading,
            error,
            user,
            transactions,
            offsetKeyDate,
            noTransactions,
            environment,
            streetAddr
        } = this.props

        const {
            width,
            height,
            modalOpen,
            modalType
        } = this.state

        const thisPeriod = !offsetKeyDate || !offsetKeyDate.date ? true : offsetKeyDate.inCycle
        const currentIdentityBadge = getAvatar(user.currentIdentity)

        let data = { aggregation: [], sum: { Revenue: 0, Investment: 0 }, status: 'loading' }
        if (error) {
            data.status = 'error'
        } else if (noTransactions) {
            data.status = 'empty'
        } else if (transactions) {
            try {
                data = prepTransactions(transactions, offsetKeyDate)
                data.status = 'fetched'
            } catch (e) {
                data.status = 'error'
            }
        }

        return (
            <View style={styles.container}
                onLayout={(evt) => { this.onLayout(evt.nativeEvent.layout) }}>

                <TouchableOpacity
                    style={styles.avatar}
                    onPress={() => { this.openModal('profile') }}
                    activeOpacity={0.8}>
                        <View style={styles.identity}>
                            <View style={[currentIdentityBadge.badgeStyle, styles.badgeStyle]}>
                                <Image style={styles.badgeImageStyle}
                                    source={currentIdentityBadge.badgeImage} />
                            </View>
                            <View style={{ flexDirection: 'column' }}>
                                <Text style={styles.username}>
                                    {user.currentIdentity && user.currentIdentity.name
                                        ? user.currentIdentity.name
                                        : 'Meet Carrot Merchant'}
                                </Text>
                                {streetAddr && streetAddr.value && <Text style={styles.street}>
                                    {streetAddr.value}
                                </Text>}
                            </View>
                        </View>
                </TouchableOpacity>

                {('loading' === data.status || isLoading) &&
                    <View style={styles.cardStyle}>
                        <LoadingCard
                            cardStyle={{ width: ~~(0.75*width), height: ~~(0.6*height) }}
                            offsetKeyDate={offsetKeyDate} />
                    </View>}

                {'empty' === data.status && !isLoading &&
                    <View style={styles.cardStyle}>
                        <EmptyCard
                            cardStyle={{ width: ~~(0.75*width), height: ~~(0.6*height) }}
                            offsetKeyDate={offsetKeyDate} />
                    </View>}

                {'error' === data.status && !isLoading &&
                    <View style={styles.cardStyle}>
                        <ErrorCard
                            cardStyle={{ width: ~~(0.75*width), height: ~~(0.6*height) }}
                            offsetKeyDate={offsetKeyDate} />
                    </View>}

                {'fetched' === data.status && !isLoading && <View style={{ flex: 6, alignSelf: 'stretch' }}>
                    <ScrollView
                        contentContainerStyle={{ alignItems: 'center'}}
                        horizontal={true}>
                            <Card
                                cardStyle={{ width: ~~(0.75*width), height: ~~(0.6*height), margin: 10 }}
                                title={'Revenue'}
                                data={data}
                                offsetKeyDate={offsetKeyDate}
                                primaryColor={'#4CD85E'}
                                onPress={() => { this.openModal('revenue') }} />

                            <Card
                                cardStyle={{ width: ~~(0.75*width), height: ~~(0.6*height), margin: 10 }}
                                title={'Investment'}
                                data={data}
                                offsetKeyDate={offsetKeyDate}
                                primaryColor={'#FF009B'}
                                onPress={() => { this.openModal('income') }} />
                    </ScrollView>
                </View>}

                <View style={styles.datePicker}>
                    <TouchableOpacity
                        style={{ flex: 1, justifyContent: 'center', alignItems: 'flex-end' }}
                        onPress={() => { this.fetchTransactions('prev') }}
                        activeOpacity={0.8}>
                        <Text style={styles.datePickerText}>
                            &lt;&lt;
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                        style={{ flex: 3, justifyContent: 'center', alignItems: 'center' }}
                        onPress={() => { !thisPeriod && this.fetchTransactions('current') }}
                        activeOpacity={0.8}>
                        <Text style={styles.datePickerText}>
                            {offsetKeyDate && dateRangeFormat(offsetKeyDate)}
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                        style={{ flex: 1, justifyContent: 'center', alignItems: 'flex-start' }}
                        onPress={() => { !thisPeriod && this.fetchTransactions('next') }}
                        activeOpacity={0.8}>
                        <Text style={[styles.datePickerText, thisPeriod && { opacity: 0.2 }]}>
                            &gt;&gt;
                        </Text>
                    </TouchableOpacity>
                </View>

                {environment && 'live' !== environment &&
                    <View style={{ position: 'absolute', bottom: 10}}>
                        <Text style={{ fontSize: 14, color: 'red' }}>
                            {environment.toUpperCase()}
                        </Text>
                    </View>}

                <Modal
                    open={modalOpen}
                    closeOnTouchOutside={false}
                    // modalDidOpen={() => {
                    //     console.log('Modal did open.')
                    // }}
                    modalDidClose={() => {
                        this.closeModal()
                        // console.log('Modal did close.')
                    }}
                    // modalStyle={{
                    //     width,
                    //     height
                    // }}
                    containerStyle={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>

                    <View style={{ flex: 1, alignItems: 'center' }}>
                        {'revenue' === modalType &&
                            <Financials
                                isLoading={isLoading}
                                title={'Revenue'}
                                layout={{ width, height }}
                                data={data}
                                primaryColor={'#4CD85E'}
                                selectedColor={'red'}
                                transactions={transactions}
                                offsetKeyDate={offsetKeyDate}
                                onClose={this.closeModal}/>}

                        {'income' === modalType &&
                            <Financials
                                isLoading={isLoading}
                                title={'Investment'}
                                layout={{ width, height }}
                                data={data}
                                primaryColor={'#FF009B'}
                                selectedColor={'red'}
                                transactions={transactions}
                                offsetKeyDate={offsetKeyDate}
                                onClose={this.closeModal}/>}

                        {'profile' === modalType &&
                            <Profile onClose={this.closeModal} />}

                    </View>
                </Modal>
            </View>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        path: state['router'].location.pathname,
        user: stateGetInToJS(state, MainReducer.NAME, ['user'], 'Dashboard'),
        isLoading: stateGetIn(state, DashboardReducer.NAME, ['loading'], 'Dashboard') === true,
        error: stateGetIn(state, DashboardReducer.NAME, ['error'], 'Dashboard'),
        transactions: stateGetInToJS(state, DashboardReducer.NAME, ['transactions'], 'Dashboard', []),
        offsetKeyDate: stateGetInToJS(state, DashboardReducer.NAME, ['offsetKeyDate'], 'Dashboard'),
        noTransactions: stateGetIn(state, DashboardReducer.NAME, ['noTransactions'], 'Dashboard') === true,
        environment: stateGetIn(state, MainReducer.NAME, ['environment'], 'Dashboard')
    }
}

const mapDispatchToProps = (dispatch) => ({
    clear: () => {
        dispatch(DashboardReducer.clear())
    },
    fetchTransactions: (
        period = 'current',
        unit = 'week'
    ) => {
        dispatch(DashboardReducer.fetchTransactions(period, unit))
    },
    goHome: () => {
        dispatch(push('/dashboard'))
    },
    resetProfileSettings: () => {
        dispatch(MainReducer.resetProfileSettings())
    }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        admin: stateProps.user && stateProps.user.userSettings &&
                (stateProps.user.userSettings.carrotUser || stateProps.user.userSettings.adminOverride),
        streetAddr: stateProps.user && stateProps.user.endpoints &&
            stateProps.user.endpoints.find((endpoint) => CONSTANTS.ENDPOINT_TYPES.ADDRESS === endpoint.endpoint_type)
    })
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js